const colors = [
        "#1abc9c", "#2ecc71", "#3498db", "#9b59b6", "#34495e",
        "#16a085", "#27ae60", "#2980b9", "#8e44ad", "#2c3e50",
        "#f1c40f", "#e67e22", "#e74c3c", "#95a5a6", "#f39c12",
    ];
// Shared logic for generating the data URL
const getAvatarDataUrl = (firstName, lastName, size = 40) => {
    const firstInitial = firstName?.charAt(0)?.toUpperCase() || "";
    const lastInitial = lastName?.charAt(0)?.toUpperCase() || "";
    const initials = firstInitial + lastInitial || "?";

    const fullName = `${firstName} ${lastName}`;
    const colorIndex = fullName.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) % colors.length;
    
    // Scale font size proportionally to the size
    const baseFontSize = initials.length > 1 ? 16 : 20;
    const fontSize = (baseFontSize / 40) * size;
    
    // Center point scales with size
    const center = size / 2;

    const svg = `<svg width="${size}" height="${size}" xmlns="http://www.w3.org/2000/svg"><rect width="${size}" height="${size}" fill="${colors[colorIndex]}"/><text x="${center}" y="${center}" text-anchor="middle" dy="0.3em" fill="white" font-family="Arial" font-size="${fontSize}" font-weight="bold">${initials}</text></svg>`;
    return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
};

export const getColorByName = (firstName, lastName) => {
    const fullName = `${firstName} ${lastName}`;
    const colorIndex = fullName.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0) % colors.length;
    return colors[colorIndex];
}

// For string-based HTML (your existing usage)
export const getInitialAvatar = (firstName, lastName, size) => {
    const dataUrl = getAvatarDataUrl(firstName, lastName, size);
    return `<img src="${dataUrl}" alt="${firstName} ${lastName}" style="width: 100%; height: 100%; object-fit: cover;" />`;
};

// For JSX usage
export const getInitialAvatarJSX = (firstName, lastName, props = {}, size) => {
    const dataUrl = getAvatarDataUrl(firstName, lastName, size);
    return (
        <img 
            src={dataUrl} 
            alt={`${firstName} ${lastName}`} 
            {...props}
        />
    );
};

export const splitNames = (fullName = '') => {
  const parts = String(fullName).trim().split(/\s/);
  return {
    firstName: parts[0] || '',
    lastName: parts.slice(1).join(' ') || ''
  };
};
export const deriveNames = (user = {}) => {
  if (user.firstName || user.lastName) {
    return { firstName: user.firstName || '', lastName: user.lastName || '' };
  }
  if (user.name) return splitNames(user.name);
  if (user.display_name) return splitNames(user.display_name);
  if (user.username) return splitNames(user.username);
  return { firstName: '', lastName: '' };
};